import { Button, Modal } from "antd";
import React from "react";
interface props {
  onCancel: any;
  isModelOpen: boolean;
}
const ViewData = ({ onCancel, isModelOpen }: props) => {
  return (
    <>
      <Modal
        title="View Details"
        onCancel={() => onCancel(false)}
        open={isModelOpen}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => onCancel(false)}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            {/* <Button loading={btnLoading} type="primary" onClick={saveData}>
              Save
            </Button> */}
          </div>
        }
      ></Modal>
    </>
  );
};

export default ViewData;
